import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageTitle } from './PageTitle';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-291">
      <PageTitle data-id="element-292" />
      <TopBar data-id="element-293" />
      <Header data-id="element-294" />
      <main className="flex-1" data-id="element-295">
        <Outlet data-id="element-296" />
      </main>
      <Footer data-id="element-297" />
    </div>;
}